<ng-content>
</ng-content>

@if (!layoutContent && autofill) {
  <ng-template [ngTemplateOutlet]="elementsTemplate"></ng-template>
}

<ng-template #elementsTemplate>
  @for (element of content; track element.element.id) {
    <wct-element-host [element]="element" [options]="autofillOptions"/>
  }
</ng-template>

@if (loading()) {
  <sd-4-5-1-spinner></sd-4-5-1-spinner>
}
